import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
  provideRouter,
  withDebugTracing,
  withEnabledBlockingInitialNavigation,
  withHashLocation,
} from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      // Remove withHashLocation() if you get Apache rewrites working
      // withHashLocation(), // Uncomment this if Apache rewrites fail
      // withEnabledBlockingInitialNavigation()
      // withDebugTracing() // Uncomment for route debugging
    ),
    provideHttpClient(withFetch()),
    provideClientHydration(), provideClientHydration(withEventReplay()),
  ],
};
